import React, { useEffect, createElement } from 'react';
import { CheckIcon, ShieldCheckIcon, SparklesIcon, StarIcon, SettingsIcon } from 'lucide-react';
import { Accordion } from '../components/Accordion';
import { Countdown } from '../components/Countdown';
import { InstagramCarousel } from '../components/InstagramCarousel';
import { PurchaseButton } from '../components/PurchaseButton';
import { SocialProof } from '../components/SocialProof';
import { useScreenInit } from '../useScreenInit';
const productImage = 'https://cdn.magicpatterns.com/uploads/wncy7SsRThc6bzLn9W6iHq/ChatGPT_Image_Jul_9,_2026,_11_10_31_PM.png';
const modules = [{
  title: 'MÓDULO 1 — Fundamentos',
  previewImage: 'https://cdn.magicpatterns.com/uploads/dXWibsVBTCC6DjiqPyyu4x/pasted-image.png',
  previewAlt: 'Práctica de yoga y respiración consciente',
  lines: ['Respiración (pranayama): diafragmática, Ujjayi, 4-7-8', 'Alineación postural: 4 errores comunes y su corrección', 'Equipo y espacio de práctica', 'Escala de esfuerzo percibido', 'Cierre del módulo']
}, {
  title: 'MÓDULO 2 — Fase 1: Días 1-30 (Base)',
  previewImage: 'https://cdn.magicpatterns.com/uploads/471sk3Be7ymT1GyixXKgpG/pasted-image.jpg',
  previewAlt: 'Postura de yoga de fortalecimiento frente al mar',
  lines: ['Estructura de la sesión diaria', 'Banco de 15 posturas fundamentales', 'Semana por semana desglosada', 'Journaling y seguimiento', 'Casos de uso por problemática', 'FAQ Fase 1']
}, {
  title: 'MÓDULO 3 — Fase 2: Días 31-60 (Fortalecimiento)',
  previewImage: 'https://cdn.magicpatterns.com/uploads/1JqYMux2rZ4JwSE9N2VuE6/pasted-image.jpg',
  previewAlt: 'Postura de equilibrio invertida en práctica de yoga',
  lines: ['Estructura de la sesión diaria', 'Banco de 10 posturas nuevas (fuerza y equilibrio)', 'Semana por semana desglosada', 'Ajustes según feedback de Fase 1', 'Introducción a secuencias combinadas', 'FAQ Fase 2']
}, {
  title: 'MÓDULO 4 — Fase 3: Días 61-90 (Integración)',
  previewImage: 'https://cdn.magicpatterns.com/uploads/nqAhKgAyfC4YPzZUt4ySSo/pasted-image.webp',
  previewAlt: 'Postura de guerrero en estudio de yoga',
  lines: ['Los 4 Flows completos (columna, piernas/cadera, equilibrio/core, integrador)', 'Semana por semana desglosada', 'Posturas de cierre de programa', 'Plan de mantenimiento post-90 días', 'FAQ Fase 3']
}, {
  title: 'MÓDULO 5 — Nutrición y descanso complementario',
  previewImage: 'https://cdn.magicpatterns.com/uploads/aa4NjN7tctZqrnThzShNox/pasted-image.jpg',
  previewAlt: 'Alimentación consciente como complemento de la práctica',
  lines: ['Alimentación antiinflamatoria + menú semanal orientativo', 'Higiene del sueño', 'Manejo de estrés complementario', 'Cierre general del programa (90 días)']
}];
const bonuses = [{
  title: 'BONUS A — Yoga para oficinistas (cervical-lumbar)',
  lines: ['Autoevaluación postural de oficina', 'Ergonomía express (silla, pantalla, checklist)', 'Rutina de escritorio (mañana/mediodía/tarde)', 'Secuencia noche: revertir 8 horas de sedestación', 'Micro-pausas activas', 'Cuándo consultar al médico', 'Plan semanal integrado']
}, {
  title: 'BONUS B — Yoga para dormir (insomnio)',
  lines: ['Autoevaluación de tipo de insomnio', 'Secuencia pre-sueño (10 min)', 'Respiración 4-7-8 y variantes', 'Yoga Nidra guiado (guion completo)', 'Qué NO hacer antes de dormir', 'Rutina nocturna integrada', 'FAQ insomnio y yoga']
}, {
  title: 'BONUS C — Yoga postparto y diástasis abdominal',
  lines: ['Disclaimer médico + qué es la diástasis', 'Test de autoevaluación (cómo medirla)', 'Fundamentos de reconexión del core (por qué no abdominales clásicos)', 'Progresión por etapa: semanas 0-6 / 6-12 / 12+', 'Posturas contraindicadas', 'Señales de alerta', 'FAQ postparto']
}, {
  title: 'BONUS D — Yoga para adultos mayores / movilidad articular',
  lines: ['Disclaimer + beneficios específicos', 'Autoevaluación de movilidad y riesgo de caída', 'Segmentación por nivel de autonomía (Nivel 1 / Nivel 2)', 'Secuencia en silla (por nivel)', 'Secuencia en piso con apoyo (por nivel)', 'Fuerza funcional adaptada', 'Trabajo específico de equilibrio', 'Movilidad articular por zona (cadera, rodillas, hombros)', 'Guía para el acompañante', 'Señales de alerta y cuándo frenar', 'Rutina semanal sugerida']
}, {
  title: 'BONUS E — Yoga terapéutico por patología',
  lines: ['Protocolo ciática (secuencia + contraindicaciones)', 'Protocolo hernia de disco lumbar y cervical (secuencias + contraindicaciones)', 'Protocolo migrañas/cefaleas tensionales (secuencia + automasaje)', 'Cuándo este bonus no reemplaza atención médica']
}, {
  title: 'BONUS F — Explorá otros estilos de yoga',
  lines: ['Guía comparativa de 8 estilos (Hatha, Vinyasa, Yin, Restorative, Kundalini, Bikram/Hot, Iyengar, Ashtanga)', 'Secuencia de muestra: Yin (15 min)', 'Secuencia de muestra: Restorative (15 min)', 'Secuencia de muestra: Kundalini (10 min)', 'Dónde seguir cada estilo']
}, {
  title: 'BONUS G — Manual de Talleres y Retiros para el Profesor de Yoga',
  lines: ['Introducción: taller vs. workshop vs. retiro', 'Diseño del taller (estructura, secuencia, materiales)', 'Diseño del retiro (sede, cronograma, comidas/alojamiento)', 'Precios y rentabilidad (costos, punto de equilibrio, tabla de precios)', 'Promoción y venta (plantillas de invitación, lista de espera)', 'Logística del día del evento (checklists pre/día/imprevistos)', 'Después del evento (feedback, conversión a alumnos regulares, calendario anual)', 'Plantillas descargables (presupuesto, cronograma, checklist)']
}];
const painPoints = ['Dolor de espalda al terminar tu jornada', 'Rigidez en cuello y hombros por tantas horas frente a la pantalla', 'Posturas que te hacen sentir más cansada que antes', 'Menos independencia y confianza para moverte', 'La sensación de no tener tiempo ni saber por dónde empezar'];
const testimonials = [['Mariela, 42 · Buenos Aires', 'Trabajo 8 horas sentada y tenía la espalda tomada. Las rutinas me dieron una forma simple de volver a moverme sin exigirme de más.'], ['Luciana, 36 · Córdoba', 'Me gustó que puedo seguirlo a mi ritmo. En pocas semanas ya noté menos tensión en la cervical.'], ['Patricia, 58 · Rosario', 'Necesitaba algo claro y cuidado para mi movilidad. El programa me acompaña día a día y me siento más segura.'], ['Carla, 31 · La Plata', 'Después del postparto quería reconectar sin hacer cualquier cosa. El bonus específico fue justo lo que estaba buscando.'], ['Silvia, 64 · Mendoza', 'Las opciones adaptadas me devolvieron confianza. Hoy hago mi práctica con calma y constancia.']];
export function Home() {
  useScreenInit();
  useEffect(() => {
    const metaWindow = window as typeof window & {
      fbq?: (...args: unknown[]) => void;
    };
    if (!metaWindow.fbq) {
      const fbq = (...args: unknown[]) => {
        ;
        (fbq as typeof fbq & {
          queue?: unknown[][];
        }).queue = [...((fbq as typeof fbq & {
          queue?: unknown[][];
        }).queue ?? []), args];
      };
      (fbq as typeof fbq & {
        queue?: unknown[][];
        loaded?: boolean;
        version?: string;
      }).queue = [];
      metaWindow.fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      metaWindow.fbq('init', '1252242806993118');
    }
    if (!document.documentElement.dataset.yoga360MetaPageview) {
      metaWindow.fbq?.('track', 'PageView');
      document.documentElement.dataset.yoga360MetaPageview = 'true';
    }
  }, []);
  return <main className="relative min-h-screen overflow-hidden bg-[#f6f1e7] text-[#263a2a]" data-id="element-44">
      <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden bg-[#e6e0d1]" aria-hidden="true" data-id="element-45">
        <img src={productImage} alt="" className="h-full w-full scale-110 object-cover opacity-20 blur-xl" data-id="element-46" />
        <div className="absolute inset-0 bg-[#f6f1e7]/80" data-id="element-47" />
      </div>

      <header className="border-b border-[#5b7255]/15 bg-[#fffdf8]/90 px-5 py-3 backdrop-blur-sm" data-id="element-48">
        <div className="mx-auto flex max-w-5xl items-center justify-center gap-2 text-xs font-bold uppercase tracking-[0.12em] text-[#526b50]" data-id="element-49">
          <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-50" /> Kit Yoga360 ·
          90 días para vos
        </div>
      </header>

      <section className="mx-auto max-w-xl px-5 pb-12 pt-10 text-center sm:pt-14" data-id="element-51">
        <p className="mb-3 text-xs font-bold uppercase tracking-[0.16em] text-[#b85f42]" data-id="element-52">
          Programa digital de bienestar
        </p>
        <h1 className="font-serif text-4xl font-semibold leading-[1.06] tracking-tight text-[#263a2a] sm:text-5xl" data-id="element-53">
          El manual de yoga que se adapta a vos y no al reves
        </h1>
        <a href="#oferta-final" className="mt-7 block overflow-hidden rounded-2xl border-4 border-[#fffaf1] shadow-xl focus:outline-none focus-visible:ring-4 focus-visible:ring-[#b85f42]/40" aria-label="Ver la oferta del Kit Yoga360" data-id="element-54">
          <img src={productImage} alt="Kit Yoga360, programa de yoga de 90 días con módulos y bonos" className="w-full object-cover" data-id="element-55" />
        </a>
        <p className="mx-auto mt-7 max-w-md text-lg leading-7 text-[#405040]" data-id="element-56">
          Un programa de yoga de 90 días con rutinas específicas para tu dolor,
          tu edad y tu momento de vida — sin necesitar experiencia previa.
        </p>
        <div className="mt-7 grid grid-cols-3 gap-2 text-left" data-id="element-57">
          {['📄 100% PDF', '⚡️ Entrega Inmediata', '📚 5 Modulos + 7 Bonos'].map(badge => <div key={badge} className="rounded-xl border border-[#5b7255]/20 bg-[#fffdf8]/90 px-2 py-3 text-center text-xs font-bold leading-4 text-[#3f573d]" data-id="element-58">
              {badge}
            </div>)}
        </div>
        <div className="mt-7" data-id="element-59">
          <PurchaseButton data-id="element-60" />
        </div>
      </section>

      <section className="bg-[#263a2a] px-5 py-12 text-[#fffaf1]" data-id="element-61">
        <div className="mx-auto max-w-xl" data-id="element-62">
          <h2 className="font-serif text-3xl leading-tight" data-id="element-63">
            Muchas veces nos olvidamos de nuestro cuerpo, y puede terminar en:
          </h2>
          <ul className="mt-7 space-y-3" data-id="element-64">
            {painPoints.map(item => <li key={item} className="flex items-start gap-3 rounded-xl border border-white/15 bg-white/5 p-3 text-sm leading-5" data-id="element-65">
                <span className="mt-0.5 text-[#e6b28d]" data-id="element-66">✦</span>
                {item}
              </li>)}
          </ul>
        </div>
      </section>

      <section className="mx-auto max-w-xl px-5 py-14" data-id="element-67">
        <div className="text-center" data-id="element-68">
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#b85f42]" data-id="element-69">
            Tu recorrido, en orden
          </p>
          <h2 className="mt-2 font-serif text-3xl leading-tight" data-id="element-70">
            por eso, creamos este Kit, preparado para adaptarse a vos
          </h2>
        </div>
        <div className="mt-8 space-y-3" data-id="element-71">
          {modules.map(module => <Accordion key={module.title} {...module} data-id="element-72" />)}
        </div>
        <div className="mt-8" data-id="element-73">
          <PurchaseButton label="Quiero empezar mis 90 días" data-id="element-74" />
        </div>
      </section>

      <section className="border-y border-[#d9d2c4] bg-[#fffaf1] px-5 py-14" data-id="element-75">
        <div className="mx-auto max-w-xl" data-id="element-76">
          <div className="text-center" data-id="element-77">
            <p className="flex justify-center gap-1 text-[#b85f42]" data-id="element-78">
              {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-79" />)}
            </p>
            <h2 className="mt-3 font-serif text-3xl" data-id="element-80">
              Historias de bienestar real
            </h2>
          </div>
          <div className="mt-8 space-y-4" data-id="element-81">
            {testimonials.map(([person, quote]) => <article key={person} className="rounded-2xl border border-[#d9d2c4] bg-white p-5 shadow-sm" data-id="element-82">
                <div className="flex gap-1 text-[#b85f42]" data-id="element-83">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-84" />)}
                </div>
                <blockquote className="mt-3 text-sm leading-6 text-[#465346]" data-id="element-85">
                  “{quote}”
                </blockquote>
                <p className="mt-3 text-xs font-bold text-[#526b50]" data-id="element-86">
                  {person}
                </p>
              </article>)}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-xl px-5 py-14" data-id="element-87">
        <p className="text-center text-xl tracking-[0.2em] text-[#b85f42]" data-id="element-88">
          xxxxxxxx
        </p>
        <div className="mt-5 text-center" data-id="element-89">
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#b85f42]" data-id="element-90">
            Incluidos con tu kit
          </p>
          <h2 className="mt-2 font-serif text-3xl" data-id="element-91">
            7 bonos para acompañarte en cada etapa
          </h2>
        </div>
        <div className="mt-8 space-y-3" data-id="element-92">
          {bonuses.map(bonus => <Accordion key={bonus.title} {...bonus} tone="bonus" data-id="element-93" />)}
        </div>
      </section>

      <InstagramCarousel data-id="element-94" />

      <section className="bg-[#e7dece] px-5 py-12" data-id="element-95">
        <div className="mx-auto max-w-xl" data-id="element-96">
          <h2 className="text-center font-serif text-3xl" data-id="element-97">
            Sin Kit yoga360 vs Con Kit yoga360
          </h2>
          <div className="mt-7 overflow-hidden rounded-2xl border border-[#c7bca9] bg-[#fffdf8]" data-id="element-98">
            <div className="grid grid-cols-2 text-center text-xs font-bold uppercase tracking-wide" data-id="element-99">
              <div className="bg-[#eaded2] px-2 py-3 text-[#7d594d]" data-id="element-100">
                Sin Kit yoga360
              </div>
              <div className="bg-[#526b50] px-2 py-3 text-white" data-id="element-101">
                Con Kit yoga360
              </div>
            </div>
            {[['Rutinas al azar', 'Plan de 90 días'], ['Dolor sin guía', 'Práctica adaptada'], ['Sin seguimiento', 'Semana a semana'], ['Todo por resolver', '5 módulos + 7 bonos']].map(([without, withKit]) => <div key={without} className="grid grid-cols-2 border-t border-[#ded6c7] text-center text-xs leading-4" data-id="element-102">
                <div className="px-2 py-3 text-[#705d55]" data-id="element-103">{without}</div>
                <div className="border-l border-[#ded6c7] px-2 py-3 font-semibold text-[#355135]" data-id="element-104">
                  {withKit}
                </div>
              </div>)}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-xl px-5 py-12" data-id="element-105">
        <div className="rounded-2xl border border-[#c77f60]/35 bg-[#fff8ed] p-6 text-center" data-id="element-106">
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#b85f42]" data-id="element-107">
            Hoy es un buen día para empezar
          </p>
          <h2 className="mt-3 font-serif text-3xl leading-tight" data-id="element-108">
            Toma accion, y empeza por mejorar tu bienestar a partir de hoy
          </h2>
          <div className="mt-6" data-id="element-109">
            <a href="#oferta-final" className="inline-flex rounded-full border border-[#b85f42]/35 px-4 py-2 text-xs font-bold text-[#8b4a33] transition hover:bg-[#fff1df] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#b85f42]/35" data-id="element-110">
              Ver oferta final
            </a>
          </div>
        </div>
      </section>

      <section id="oferta-final" className="scroll-mt-4 bg-[#263a2a] px-5 py-14 text-[#fffaf1]" data-id="element-111">
        <div className="mx-auto max-w-xl" data-id="element-112">
          <div className="rounded-2xl bg-[#fffaf1] p-5 text-[#263a2a] shadow-2xl" data-id="element-113">
            <p className="text-center text-xs font-bold uppercase tracking-[0.15em] text-[#b85f42]" data-id="element-114">
              Oferta final · acceso inmediato
            </p>
            <h2 className="mt-2 text-center font-serif text-3xl leading-tight" data-id="element-115">
              Tu resumen de pedido
            </h2>
            <div className="mt-6 space-y-3 border-y border-[#ddd4c5] py-5 text-sm" data-id="element-116">
              <p className="flex justify-between gap-4" data-id="element-117">
                <span data-id="element-118">Kit Yoga360 — programa de 90 días</span>
                <CheckIcon className="h-5 w-5 shrink-0 text-[#5b7255]" data-id="element-119" />
              </p>
              <p className="flex justify-between gap-4" data-id="element-120">
                <span data-id="element-121">5 módulos en PDF</span>
                <CheckIcon className="h-5 w-5 shrink-0 text-[#5b7255]" data-id="element-122" />
              </p>
              <p className="flex justify-between gap-4" data-id="element-123">
                <span data-id="element-124">7 bonos complementarios gratis hoy</span>
                <CheckIcon className="h-5 w-5 shrink-0 text-[#5b7255]" data-id="element-125" />
              </p>
              <p className="flex justify-between gap-4" data-id="element-126">
                <span data-id="element-127">Entrega inmediata</span>
                <CheckIcon className="h-5 w-5 shrink-0 text-[#5b7255]" data-id="element-128" />
              </p>
            </div>
            <div className="mt-6 text-center" data-id="element-129">
              <p className="text-sm text-[#7e7166]" data-id="element-130">
                Precio anterior <s data-id="element-131">$58.990</s>
              </p>
              <p className="font-serif text-5xl font-semibold text-[#b85f42]" data-id="element-132">
                $19.990
              </p>
            </div>
            <div className="mt-5" data-id="element-133">
              <Countdown data-id="element-134" />
            </div>
            <div className="mt-4 rounded-xl bg-[#e7eee2] p-4" data-id="element-135">
              <div className="flex justify-between text-xs font-bold text-[#405b3d]" data-id="element-136">
                <span data-id="element-137">Cupos restantes</span>
                <span data-id="element-138">930 cupos</span>
              </div>
              <div className="mt-2 h-2 overflow-hidden rounded-full bg-[#c7d3bf]" data-id="element-139">
                <div className="h-full w-[31%] rounded-full bg-[#5b7255]" data-id="element-140" />
              </div>
            </div>
            <div className="mt-6" data-id="element-141">
              <PurchaseButton label="Quiero recuperar mi bienestar" data-id="element-142" />
            </div>
            <div className="mt-5 flex items-center justify-center gap-2 text-xs text-[#5c675c]" data-id="element-143">
              <ShieldCheckIcon className="h-4 w-4 text-[#5b7255]" aria-hidden="true" data-id="element-144" />{' '}
              Compra segura · Acceso digital inmediato
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#fffaf1] px-5 py-14" data-id="element-145">
        <div className="mx-auto max-w-xl" data-id="element-146">
          <div className="text-center" data-id="element-147">
            <div className="mx-auto h-7 w-7 text-[#b85f42]" aria-hidden="true" data-id="element-148" />
            <h2 className="mt-2 font-serif text-3xl" data-id="element-149">
              Preguntas antes de empezar
            </h2>
          </div>
          <dl className="mt-8 space-y-3" data-id="element-150">
            {[['¿Necesito tener experiencia previa?', 'No. El programa está preparado para que puedas empezar desde tu momento actual.'], ['¿Cómo recibo el contenido?', 'Vas a recibir el material en formato PDF con entrega inmediata después de tu compra.'], ['¿Y si tengo una molestia o patología?', 'El kit incluye contenido orientativo, pero no reemplaza la atención de un profesional de la salud cuando sea necesaria.'], ['¿Puedo hacerlo si trabajo muchas horas?', 'Sí. Encontrás prácticas y bonus pensados para quienes pasan gran parte del día en oficina o sentados.']].map(([question, answer]) => <div key={question} className="rounded-xl border border-[#d9d2c4] p-4" data-id="element-151">
                <dt className="font-semibold text-[#334a34]" data-id="element-152">{question}</dt>
                <dd className="mt-2 text-sm leading-6 text-[#596459]" data-id="element-153">
                  {answer}
                </dd>
              </div>)}
          </dl>
        </div>
      </section>

      <footer className="bg-[#e7dece] px-5 py-8 text-center" data-id="element-154">
        <div className="flex items-center justify-center gap-2 text-sm font-semibold text-[#435443]" data-id="element-155">
          <SettingsIcon className="h-5 w-5" aria-hidden="true" data-id="element-156" />{' '}
          <a href="mailto:EbookDreamShop@gmail.com" className="underline decoration-[#b85f42] underline-offset-4" data-id="element-157">
            EbookDreamShop@gmail.com
          </a>
        </div>
        <p className="mt-3 text-xs text-[#697169]" data-id="element-158">Soporte · Kit Yoga360</p>
      </footer>
      <SocialProof data-id="element-159" />
    </main>;
}